import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetCoupon, doGetCoupons, doUpdateCoupon } from '../../../store/coupon.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/business/coupon/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const BusinessCouponEdit: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { coupons, isLoading } = useSelector((state: RootState) => state.coupon);

  const match = useRouteMatch<IMatch>();
  const id = Number(match.params.id);

  useEffect(() => {
    getCoupon();
  }, []);

  const getCoupon = async () => {
    const res = await dispatch(doGetCoupon(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }
  const onSubmit = async (req: any) => {
    const res = await dispatch(doUpdateCoupon(id, req));

    switch (res?.status) {
      case 200:
        dispatch(doGetCoupons());
        enqueueSnackbar(t('common.message.edit1'), successVariant);
        history.push(`/business/coupon${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.business')}
        currentMenu={t('business.coupon.title2')}
      />
      <Editor
        coupon={coupons[0] || null}
        onSubmit={onSubmit}
      />
      <Footer />
    </div>
  )
}

export default BusinessCouponEdit;
